import { render } from "./TopBar.vue?vue&type=template&id=5f660b70"
import script from "./TopBar.vue?vue&type=script&lang=ts"
export * from "./TopBar.vue?vue&type=script&lang=ts"
script.render = render

export default script